import { ServingLine } from "@/models";
import { ServingLineViewModel } from '@/view-models';

export class ServingLineSummary {
  vms: ServingLineViewModel[] = [];

  constructor(public servingLines: ServingLine[]) {  
    servingLines?.forEach(m => this.vms.push(new ServingLineViewModel(m)));
  }

  get firstMeal() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountServedFirstMeal;
    }
    return result;
  }

  get secondMeal() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountServedSecondMeal;
    }
    return result;
  }

  get adultProgramMeal() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountServedAdultProgram;
    }
    return result;
  }

  get adultNonprogramMeal() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountServedAdultNonProgram;
    }
    return result;
  }

  get mealCountLeftover() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountLeftover;
    }
    return result;
  }

  get nonCongregateMeal() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountNonCongregateMeal;
    }
    return result;
  }

  get incompleteMeal() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountIncomplete;
    }
    return result;
  }

  get wastedMeal() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountWaste;
    }
    return result;
  }

  get additionalMealsRequested() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountAdditionalRequested;
    }
    return result;
  }

  get nonCongregateMeals() {
    let result = 0;
    for (let line of this.vms.filter(u => !u.isMerged)) {
      result += line.servingLine.mealCountNonCongregateMeal;
    }
    return result;
  }

  get totalCount() {
    return (
      this.firstMeal +
      this.secondMeal +
      this.adultProgramMeal +
      this.adultNonprogramMeal +
      this.nonCongregateMeal
    );
  }
  
  get totalCountWithWaste() {
    return (
      this.totalCount +
      this.incompleteMeal +
      this.wastedMeal
    );
  }
}
